import { Link } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { SocialLinks } from "./SocialLinks";
import { PRODUCTS } from "../data/products";
import { LEGAL_NOTE } from "../data/brand";

const Col = ({ title, children, testId }) => (
  <div data-testid={testId}>
    <p className="text-[11px] font-mono uppercase tracking-[0.25em] text-[#EFEAE1]/40 mb-5">{title}</p>
    <ul className="space-y-3 text-sm text-[#EFEAE1]/70">{children}</ul>
  </div>
);

const Item = ({ to, children, testId }) => (
  <li><Link to={to} data-testid={testId} className="hover:text-[#C85A32] transition-colors">{children}</Link></li>
);

export const Footer = () => {
  const { t, lang, pages, config } = useStore();
  const co = config.company || {};
  const editorial = pages.filter((p) => !p.legal && p.published);
  const legal = pages.filter((p) => p.legal && p.published);
  const L = (p) => p.title?.[lang] || p.title?.fr;

  return (
    <footer className="bg-[#1C1917] text-[#EFEAE1] pt-20 pb-10 px-6 lg:px-14 xl:px-24" data-testid="site-footer">
      <div className="max-w-[1500px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-y-12 gap-x-10 pb-16 border-b border-[#EFEAE1]/10">
          <div className="lg:col-span-2 md:col-span-2">
            <p className="font-serif text-3xl tracking-[0.28em]">NŪRA</p>
            <p className="mt-4 text-sm text-[#EFEAE1]/60 max-w-xs leading-relaxed">{t.footer.tagline}</p>
            <div className="mt-6 flex flex-wrap gap-3 text-[10px] font-mono uppercase tracking-[0.2em] text-[#EFEAE1]/40">
              <span className="border border-[#EFEAE1]/20 rounded-full px-3 py-1.5">{t.hero.badge1}</span>
              <span className="border border-[#EFEAE1]/20 rounded-full px-3 py-1.5">{t.footer.securePay}</span>
            </div>
            <p className="mt-8 max-w-md text-[12px] leading-relaxed text-[#EFEAE1]/55" data-testid="footer-legal-note">{LEGAL_NOTE[lang]}</p>
          </div>

          <Col title={t.footer.shop} testId="footer-col-shop">
            {PRODUCTS.map((p) => (
              <Item key={p.id} to={`/produit/${p.id}`} testId={`footer-link-${p.id}`}>{p.name[lang]}</Item>
            ))}
          </Col>

          <Col title={t.footer.explore} testId="footer-col-explore">
            {editorial.map((p) => (
              <Item key={p.slug} to={`/p/${p.slug}`} testId={`footer-page-${p.slug}`}>{L(p)}</Item>
            ))}
            <Item to="/#ritual" testId="footer-ritual">{t.nav.ritual}</Item>
            <Item to="/#story" testId="footer-story">{t.nav.story}</Item>
            <Item to="/#contact" testId="footer-contact">{t.nav.contact}</Item>
            <Item to="/compte" testId="footer-account">{t.footer.account}</Item>
          </Col>

          <Col title={t.footer.legal} testId="footer-col-legal">
            <Item to="/informations#livraison" testId="footer-shipping">{t.footer.shippingPolicy}</Item>
            {legal.map((p) => (
              <Item key={p.slug} to={`/p/${p.slug}`} testId={`footer-legal-${p.slug}`}>{L(p)}</Item>
            ))}
            <li>
              <button
                data-testid="footer-cookies"
                onClick={() => { sessionStorage.removeItem("nura_consent"); localStorage.removeItem("nura_consent"); window.location.reload(); }}
                className="hover:text-[#C85A32] transition-colors text-left"
              >
                {t.footer.manageCookies}
              </button>
            </li>
          </Col>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center justify-between gap-4 text-[11px] font-mono uppercase tracking-[0.15em] text-[#EFEAE1]/30" data-testid="footer-bottom">
          <p>{t.footer.rights}</p>
          <div className="flex flex-wrap items-center gap-4" data-testid="footer-contacts">
            {co.email && <a href={`mailto:${co.email}`} className="hover:text-[#C85A32] transition-colors normal-case tracking-normal">{co.email}</a>}
            <SocialLinks company={co} className="text-[#EFEAE1]/70" />
          </div>
        </div>
      </div>
    </footer>
  );
};
